<template>
  <div class="container" id="clinics-module-wrapper">
    <!-- Loading state -->
    <div v-if="loading" class="padding-top-xs-1 padding-bottom-xs-1">
      <img
        class="loading-spinner-nk"
        src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
      />
    </div>

    <!-- Clinics grid -->
    <div v-else-if="cities.length > 0" class="clinics-container">
      <div class="clinics-header">
        <h1 style="font-weight: 400">Våra kliniker</h1>
        <p class="subtitle">
          Hitta kontaktinformation för våra kliniker i olika städer
        </p>
      </div>

      <div class="clinics-grid">
        <template v-for="city in cities">
          <div
            v-for="clinic in city.clinics"
            :key="`${city.id}-${clinic.name}`"
            class="clinic-card"
          >
            <!-- Clinic Cover Image Header -->
            <a :href="clinicUrl(clinic)">
              <div class="clinic-cover">
                <img
                  v-if="clinic.image"
                  :src="clinic.image"
                  :alt="clinic.name + ' - ' + city.name"
                  class="clinic-cover-image"
                />

                <!-- Cover Image Fallback -->
                <div class="cover-fallback" v-if="!clinic.image">
                  <div class="cover-fallback-text">
                    {{ clinic.name }}, {{ city.name }}
                  </div>
                </div>
              </div>
            </a>

            <!-- Clinic Content -->
            <div class="clinic-content">
              <!-- Clinic Services -->
              <h3 class="clinic-name">{{ clinic.name }}</h3>

              <div
                class="clinic-services"
                v-if="clinic.services && clinic.services.length > 0"
              >
                <div class="services-grid">
                  <span
                    v-for="service in clinic.services"
                    :key="service.service_name"
                    class="service-tag"
                  >
                    {{ service.service_name }}
                  </span>
                </div>
              </div>

              <!-- Clinic Information -->
              <div class="clinic-info">
                <div class="clinic-details">
                  <div class="detail-item" v-if="clinic.address">
                    <div class="detail-content">
                      <img
                        src="/wp-content/themes/nordiskakliniken/dist/images/location-dot.svg"
                        alt="Location"
                        style="width: 22px; height: 22px; margin-right: 10px"
                      />
                      <div v-html="clinic.address"></div>
                    </div>
                  </div>

                  <div class="detail-item" v-if="clinic.phone">
                    <div class="detail-content">
                      <img
                        src="/wp-content/themes/nordiskakliniken/dist/images/phone.svg"
                        alt="Phone"
                        style="width: 20px; height: 20px; margin-right: 10px"
                      />
                      <a
                        :href="'tel:' + clinic.phone.replace(/[^0-9+]/g, '')"
                        >{{ clinic.phone }}</a
                      >
                    </div>
                  </div>

                  <div class="detail-item" v-if="clinic.email">
                    <div class="detail-content">
                      <img
                        src="/wp-content/themes/nordiskakliniken/dist/images/envelope.svg"
                        alt="Email"
                        style="width: 20px; height: 20px; margin-right: 10px"
                      />

                      <a :href="'mailto:' + clinic.email">{{ clinic.email }}</a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Clinic Actions -->
              <div class="clinic-actions">
                <button
                  @click="getDirections(clinic)"
                  class="nk-button nk-button-transparent"
                  style="font-size: 16px"
                >
                  VÄGBESKRIVNING
                </button>
                <a
                  :href="clinicUrl(clinic)"
                  class="nk-button nk-button-transparent"
                  style="font-size: 16px"
                >
                  LÄS MER
                  <img
                    src="/wp-content/themes/nordiskakliniken/dist/images/arrow-right.svg"
                    alt="Arrow Right"
                    style="width: 20px; height: 20px"
                  />
                </a>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- No data state -->
    <div v-else class="no-data">
      <div class="no-data-icon">
        <img
          src="/wp-content/themes/nordiskakliniken/dist/images/location.svg"
          alt="Location"
          style="width: 64px; height: 64px"
        />
      </div>
      <h3>Inga kliniker hittades</h3>
      <p>Vi kunde inte hitta några kliniker just nu. Försök igen senare.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import homeUrl from '../helpers/homeUrl';

export default {
  name: 'ClinicsModule',
  data() {
    return {
      loading: true,
      cities: [],
    };
  },
  methods: {
    // The permalink from REST; the legacy ACF fallback has none.
    clinicUrl(clinic) {
      return clinic.url || homeUrl('/klinik/' + clinic.slug + '/');
    },
    async loadClinics() {
      try {
        this.loading = true;
        const response = await axios.get('/wp-json/nk/getContactInformation/');
        this.cities = response.data.data;
        console.log('Clinics loaded:', this.cities); // Debug log
      } catch (error) {
        console.error('Error loading clinics:', error);
      } finally {
        this.loading = false;
      }
    },

    getDirections(clinic) {
      if (clinic?.map_url) {
        window.open(clinic.map_url, '_blank');
        return;
      }
      const address = clinic.address
        ? clinic.address.replace(/<[^>]*>/g, '')
        : clinic.name;
      const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address
      )}`;
      window.open(mapsUrl, '_blank');
    },
  },

  mounted() {
    const preloaded =
      typeof window !== 'undefined' &&
      window.profetWPVars &&
      Array.isArray(window.profetWPVars.contactInformation)
        ? window.profetWPVars.contactInformation
        : null;
    if (preloaded) {
      this.cities = preloaded;
      this.loading = false;
    } else {
      this.loadClinics();
    }
  },
};
</script>
